const IMAGE_FORMATS = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'heic', 'avif', 'bmp']
const VIDEO_FORMATS = ['mp4', 'mov', 'webm', 'm4v', 'ogv', 'avi', 'mkv']

export interface FileTypeInfo {
  format?: string
  type?: string
  src?: string
}

export function isPdfFile(file: FileTypeInfo): boolean {
  if (file?.format === 'pdf' || file?.type === 'application/pdf') return true
  if (!file?.src) return false
  const path = file.src.split('?')[0]?.toLowerCase() ?? ''
  return path.endsWith('.pdf')
}

export function isImageFile(file: FileTypeInfo): boolean {
  if (file?.format?.startsWith('image') || file?.type?.startsWith('image')) return true
  if (file?.format && IMAGE_FORMATS.includes(file.format.toLowerCase())) return true
  if (!file?.src) return false
  const ext = file.src.split('?')[0]?.split('.').pop()?.toLowerCase() ?? ''
  return IMAGE_FORMATS.includes(ext)
}

export function isVideoFile(file: FileTypeInfo): boolean {
  if (file?.format?.startsWith('video') || file?.type?.startsWith('video')) return true
  if (file?.format && VIDEO_FORMATS.includes(file.format.toLowerCase())) return true
  if (!file?.src) return false
  const ext = file.src.split('?')[0]?.split('.').pop()?.toLowerCase() ?? ''
  return VIDEO_FORMATS.includes(ext)
}

/**
 * Assembles the playable URL for an S3-backed video, which lives at
 * `src/s3PublicKey` (mirrors ResponsiveVideo). Returns undefined when the file
 * isn't an S3 video so callers can fall back to `src`. Single source of truth
 * for the URL shape so the details pane, gallery, and expand-to-tab don't drift.
 * The leading slash guard keeps a stray `/`-prefixed key from producing a
 * double-slash / protocol-relative URL.
 */
export function getS3VideoUrl(file: { src?: string; s3PublicKey?: string }): string | undefined {
  if (!file?.src || !file?.s3PublicKey) return undefined
  return `${file.src}/${file.s3PublicKey.replace(/^\/+/, '')}`
}
